import React from 'react';
import { Box, Button } from '@mui/material';
import { useTheme } from '@mui/material/styles';
// The applicant shell (BrandShell) defines palette.brand for the main button; the admin portal's theme does not, and the
// wizard steps are also rendered there inside the staff Edit dialog — fall back to primary rather than crash.
export default function StepActions({ onBack, onNext, nextLabel = 'Continue', busy = false, hideBack = false, extra = null }) {
  const theme = useTheme(); const color = theme.palette && theme.palette.brand ? 'brand' : 'primary';
  return (<Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 3, gap: 1, flexWrap: 'wrap' }}>
    <Box>{!hideBack && <Button onClick={onBack} disabled={busy}>Back</Button>}</Box>
    <Box sx={{ display: 'flex', gap: 1 }}>{extra}<Button variant="contained" color={color} onClick={onNext} disabled={busy}>{nextLabel}</Button></Box>
  </Box>);
}
